module.exports = __webpack_public_path__ + "static/engajadoslab_2-16fa4a25f290c10ff67e48bc18d5ddd1.jpg";